import InclusionContainers from '../containers/inclusionContainers';

export const InclusionRoutes = [
  {
    key: 'inclusion',
    exact: true,
    path: '/inclusion',
    component: InclusionContainers
  }
]
